// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"3fe7e234","300":"8dd0b9f8","473":"6940d44c","496":"e148c7e3","544":"79171c8f","585":"8f5a25cd","594":"fab6b8c7","694":"41a773e2","868":"ac36fb4b","901":"4b56ac82"}[chunkId] + ".chunk.js";
};